import { Remote } from "comlink";
import { GetState, SetState } from "zustand";
import { BetStore } from "..";
import isServer from "../../../libs/is-server";
import { replaceInList } from "../../../libs/list-utils/replace-in-list";
import { Bet, PointsReduction } from "../../../types/bet";
import { IDBBetHandler } from "../../../workers/idb-bet-storer";
import { IDBBetSyncHandler } from "../../../workers/idb-bet-sync-handler";
import uploadBet from "../upload-bet";

export const updatePointsReduction = async (
  id: string,
  reductionIndex: number,
  newPointsReduction: Partial<PointsReduction>,
  set: SetState<BetStore>,
  get: GetState<BetStore>,
  idbBetWorkerApi?: Remote<IDBBetHandler>,
  idbBetSyncWorkerApi?: Remote<IDBBetSyncHandler>
): Promise<void> => {
  const { bet } = get();

  if (!bet) {
    return;
  }

  const { reductionRequirement } = bet;

  if (reductionRequirement.pointsReductions == null) {
    reductionRequirement.pointsReductions = [];
  }

  const newBet: Bet = {
    ...bet,
    reductionRequirement: {
      ...reductionRequirement,
      pointsReductions: replaceInList<PointsReduction>(
        reductionRequirement.pointsReductions,
        reductionIndex,
        {
          ...reductionRequirement.pointsReductions[reductionIndex],
          ...newPointsReduction,
        }
      ),
    },
  };

  set({
    bet: newBet,
    uploading: true,
  });

  if (!isServer) {
    uploadBet(id, newBet, () => set({ uploading: false }), idbBetSyncWorkerApi);

    if (idbBetWorkerApi) idbBetWorkerApi.storeBet(id, newBet);
  }
};
